/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// ============================================================
// CSS IMPORTS - Centralized here to ensure consistent ordering
// between yarn dev and yarn build.
// Order: Third-party lib CSS first → App-level CSS last (wins on conflict)
// ============================================================

// 1. Tailwind base reset (phải đứng đầu tiên)
import '../assets/css/main.css';

// 2. Third-party UI libraries
import 'vue-prism-editor/dist/prismeditor.min.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import 'vue-radio-toggle-buttons/dist/vue-radio-toggle-buttons.css';
import 'vue-good-table/dist/vue-good-table.css';

// 3. App-level CSS (overrides lib styles)
import '../assets/css/iconfont.css';
import '../assets/css/app.css';
import '../sass/app.scss';
import '../assets/css/style.scss';

// Initialize Global Libraries
import _ from 'lodash';
window._ = _;

import moment from 'moment';
window.moment = moment;
import './src/utils/moment-precise-range.js';

// Import main Vue app
import "./src/main.js";
